
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2Zm0 2.653A1.018 1.018 0 1 1 8 6.69a1.018 1.018 0 0 1 0-2.037Zm1.066 6.44c.161 0 .292-.13.292-.291l-.005-.57a.292.292 0 0 0-.292-.291H8.77v-2.42a.292.292 0 0 0-.292-.29H6.934a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h.292v1.55h-.292a.292.292 0 0 0-.292.29v.575c0 .16.13.291.292.291h2.132Z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM8 4.65339C8.56241 4.65339 9.01833 5.10931 9.01833 5.67171C9.01833 6.23412 8.56241 6.69004 8 6.69004C7.43759 6.69004 6.98167 6.23412 6.98167 5.67171C6.98429 5.11039 7.43868 4.656 8 4.65339ZM9.06614 11.0932C9.2272 11.0932 9.35777 10.9627 9.35777 10.8016L9.35299 10.2327C9.35299 10.0716 9.22242 9.94104 9.06135 9.94104H8.76972V7.52191C8.76972 7.36085 8.63915 7.23028 8.47809 7.23028H6.93386C6.7728 7.23028 6.64223 7.36085 6.64223 7.52191V8.09562C6.64223 8.25668 6.7728 8.38725 6.93386 8.38725H7.2255V9.93625H6.93386C6.7728 9.93625 6.64223 10.0668 6.64223 10.2279V10.8016C6.64223 10.9627 6.7728 11.0932 6.93386 11.0932H9.06614Z\" fill=\"black\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info.3d4b503425b1ce8ccf74ecb3d125bc07.svg"),
        {
          React: SvgInfo,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      